module.exports = __webpack_public_path__ + "static/fonts/roboto-v18-latin-700-037d830416495def72b7881024c14b7b.woff2";